module.exports = __webpack_public_path__ + "img/float-image-login.15ee3e1a.png";